import { render, staticRenderFns } from "./ReportShipmentReject.vue?vue&type=template&id=765db06f&"
import script from "./ReportShipmentReject.vue?vue&type=script&lang=js&"
export * from "./ReportShipmentReject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports